import { AxiosResponse } from "axios";
import { codeSuccess } from "@/services/enums/AxiosEnum.ts";

export class HttpResponse<TData = any> {
  readonly error?: boolean;
  readonly data: TData;
  readonly errorCode: string;
  readonly errorMsg: string;
  readonly status: number;

  constructor(response?: AxiosResponse, entityClass?: any, status?: number, error?: boolean) {
    this.data = response?.data
      ? entityClass
        ? new entityClass(response.data)
        : response.data
      : entityClass
        ? new entityClass()
        : response?.data;
    this.errorCode = response?.data?.code || "";
    this.errorMsg = response?.data?.message || "";
    this.status = status ?? response?.status ?? 0;
    this.error = error ?? !codeSuccess.includes(Number(response?.status) || 0);
  }
}

export class SearchResponse<TData> {
  data: TData[] = [];
  readonly status: number = 0;
  readonly errorCode: string;
  readonly errorMsg: string;
  readonly error?: boolean;
  readonly nextLink: string;
  readonly total: number;

  constructor(
    response?: AxiosResponse,
    entityClass?: any,
    isNotOdata?: boolean
  ) {
    if (isNotOdata) {
      this.data = response?.data?.length
        ? entityClass
          ? response.data.map((item: any) => new entityClass(item))
          : response.data
        : [];
    } else {
      this.data = response?.data?.value
        ? entityClass
          ? response.data.value.map((item: any) => new entityClass(item))
          : response.data.value
        : [];
    }
    this.status = response?.status || 0;
    this.errorCode = response?.data?.code || response?.data?.error?.code || "";
    this.errorMsg =
      response?.data?.message || response?.data?.error?.message || "";
    this.error = !codeSuccess.includes(Number(response?.status) || 0);
    this.nextLink =
      response?.data && response?.data["@odata.nextLink"]
        ? response.data["@odata.nextLink"]
        : "";
    this.total =
      response?.data && response?.data["@odata.count"]
        ? response.data["@odata.count"]
        : 0;
  }
}
